import TextWithSlider from './TextWithSlider';

export default TextWithSlider;